/**
 * Verifica se é um objeto.
 * @param {Objetc} object - Um objeto.
 * @returns {Boolean} Retorna true se for um object.
 */
const IsObject = function(object)
{
	return !!object && (typeof object === "object");
};

/**
 * Verifica se os objetos são iguais.
 * @param {Object} object1 - Objeto1 a ser comparado.
 * @param {Object} object2 - Objeto2 a ser comparado.
 * @returns {Boolean} Retorna true quando objetos são iguais.
 */
const IsEqual = function(object1, object2)
{
	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);
	if (keys1.length !== keys2.length) return false;

	// Precisa interar tudo, então não pode retornar depois do if.
	// eslint-disable-next-line consistent-return
	for (const key of keys1)
	{
		const val1 = object1[key];
		const val2 = object2[key];
		const areObjects = IsObject(val1) && IsObject(val2);
		if ((areObjects && !IsEqual(val1, val2)) || (!areObjects && val1 !== val2))
		{
			return false;
		}
	}
	return true;
};

/**
 * Clona Objeto
 * @param {Objetc} originalObject - Objeto a ser clonado.
 * @returns Um novo objeto com valores iguais ao que foi passado.
 */
const Clone = function(originalObject)
{
	// Retorna undefined ou null, quando parametro é nulo ou indefinido.
	if (!originalObject) return originalObject;

	const copyObject = Array.isArray(originalObject) ? [] : {};
	const originalKeys = Object.keys(originalObject);
	let value;
	originalKeys.forEach((key) =>
	{
		// Previne self-reference para objeto pai.
		if (Object.is(originalObject[key], originalObject));
		else
		{
			value = originalObject[key];
			copyObject[key] = IsObject(value) ? Clone(value) : value;
		}
	});

	return copyObject;
};

/**
 * Verifica se o objeto está vazio.
 * @param {Object} obj
 * @returns {boolean} Verdadeiro para objeto vazio
 */
const IsEmpty = function(obj)
{
	return Object.keys(obj).length === 0 && obj.constructor === Object;
};

/**
 * Agrupa um conjunto de dados pela propriedade de um objeto.
 * @param {string} objectProperty - Propriedade que deseja agrupar.
 * @param {Function} objectFactory - Factory que retorna um objeto com base em um item de dados.
 * @param {Array} data - Conjunto de dados.
 * @returns Conjunto de dados agrupados por uma propriedade.
 */
const GroupBy = function(objectProperty = "", objectFactory = null, data = [])
{
	if (objectProperty === "" || typeof objectFactory !== "function" || data.length === 0) return null;

	return data.reduce((groupedData, dataItem) =>
	{
		const newInfo = objectFactory(dataItem);

		const existingGroup = groupedData.find(item => item[objectProperty] === dataItem[objectProperty]);

		if (existingGroup)
		{
			existingGroup.info.push(newInfo);
		}
		else
		{
			groupedData.push({
				name: dataItem[objectProperty],
				info: [ newInfo ]
			});
		}

		return groupedData;
	}, []);
};

export default
{
	IsEmpty,
	IsEqual,
	IsObject,
	Clone,
	GroupBy
};
